import React, { useState } from 'react';
import cls from './CollapseAllTabs.module.css';
import cn from 'classnames';
import { tasksInformationActions } from 'entities/task/model/slice/tasksInformation';
import { useAppDispatch, useAppSelector } from '../../store';
import { Tooltip } from '../../shared/ui';
import { useTranslation } from 'react-i18next';

export function CollapseAllTabs() {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { isCollapsedTabsInList, isExpandedTabsInList } = useAppSelector(
        (state) => state.tasksInformationReducer
    );
    const [isVisible, setIsVisible] = useState(false);
    const collapseAllTabs = () => {
        dispatch(tasksInformationActions.collapseAllTabsInList());
    };
    const expandAllTabs = () => {
        dispatch(tasksInformationActions.expandAllTabsInList());
    };

    const onHover = () => {
        setIsVisible(!isVisible);
    };

    const handleClick = () => {
        if (isCollapsedTabsInList) {
            expandAllTabs();
            return;
        }
        collapseAllTabs();
    };

    return (
        <span
            onClick={handleClick}
            className={cls.CollapseAllTabs}
            onMouseEnter={onHover}
            onMouseLeave={onHover}
        >
            <Tooltip
                classes={cn(isVisible ? cls.Tooltip : cls.hidden)}
                textContent={
                    !isCollapsedTabsInList
                        ? t('Features.CollapseAllTabs.Collapse.text')
                        : t('Features.CollapseAllTabs.Expand.text')
                }
            />
            <span className={cls.svgSpan}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="9"
                    viewBox="0 0 12 9"
                    fill="none"
                    className={cn(isCollapsedTabsInList ? cls.downRotated : '')}
                >
                    <g transform="rotate(180 6 4.5)">
                        <path
                            d="M6 0.934185L12 6.93419L10.067 8.86719L6 4.80119L1.933 8.86719L1.68988e-07 6.93418L6 0.934185Z"
                            fill="white"
                        />
                    </g>
                </svg>

                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="9"
                    viewBox="0 0 12 9"
                    fill="none"
                    className={cn(isCollapsedTabsInList ? cls.upRotated : '')}
                >
                    <path
                        d="M6 0.934185L12 6.93419L10.067 8.86719L6 4.80119L1.933 8.86719L1.68988e-07 6.93418L6 0.934185Z"
                        fill="white"
                    />
                </svg>
            </span>
        </span>
    );
}
